export const hasSubscriptionCheckTimedOut = (lastCheckedTime: string) => {
    const twoHoursInMS = 2 * 60 * 60 * 1000;

    return Date.now() - new Date(lastCheckedTime).getTime() >= twoHoursInMS;
}